// import axios from "axios";

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
// });

// // Interceptor to handle 401 and refresh access token
// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     // 🔴 Handle inactive user / enterprise → logout
//     if (error.response?.status === 403) {
//       localStorage.clear();
//       sessionStorage.clear();
//       window.location.href = "/";
//       return Promise.reject(error);
//     }

//     if (error.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;

//       const refreshToken = localStorage.getItem("refresh_token");
//       if (!refreshToken) {
//         window.location.href = "/"; // redirect to login if no refresh token
//         return Promise.reject(error);
//       }

//       try {
//         const res = await axios.post(
//           `${process.env.REACT_APP_API_URL}/auth/refresh`,
//           {
//             refresh_token: refreshToken,
//           }
//         );

//         const newAccessToken = res.data.access_token;

//         // Update storage
//         localStorage.setItem("access_token", newAccessToken);
//         sessionStorage.setItem("access_token", newAccessToken);

//         // Update original request
//         originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

//         return api(originalRequest);
//       } catch (err) {
//         // Refresh token invalid → redirect to login
//         localStorage.clear();
//         sessionStorage.clear();
//         window.location.href = "/";
//         return Promise.reject(err);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default api;

import axios from "axios";
import { store } from "./redux/store";
import { startLoading, stopLoading } from "./redux/loadingSlice";

// ================================
// 🚀 CREATE AXIOS INSTANCE
// ================================
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // timeout: 2000, // ⏳ 2 sec global timeout to prevent infinite loader
});

// ================================
// 🔁 GLOBAL REQUEST INTERCEPTOR
// ================================
api.interceptors.request.use(
  (config) => {
    store.dispatch(startLoading()); // START GLOBAL LOADER
    return config;
  },
  (error) => {
    store.dispatch(stopLoading()); // STOP LOADER IF REQUEST FAILED
    return Promise.reject(error);
  }
);

// ================================
// 🔁 GLOBAL RESPONSE INTERCEPTOR
// ================================
api.interceptors.response.use(
  (response) => {
    store.dispatch(stopLoading()); // STOP LOADER ON SUCCESS
    return response;
  },

  async (error) => {
    store.dispatch(stopLoading()); // ALWAYS STOP LOADER

    const originalRequest = error.config;

    // ================================
    // ⏳ NETWORK TIMEOUT (NO RESPONSE)
    // ================================
    if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
      console.error("⏳ API Request Timeout:", error.message);
      return Promise.reject(error);
    }

    // ================================
    // 🌐 NETWORK FAILURE (NO INTERNET)
    // ================================
    if (!error.response) {
      console.error("🌐 Network error! No response from server.");
      return Promise.reject(error);
    }

    // ================================
    // ❌ 403 - Forbidden → Auto Logout
    // ================================
    if (error.response.status === 403) {
      const isLoginApi = error.config?.url?.includes("/auth/login");

      if (isLoginApi) {
        // ❌ DO NOT redirect
        return Promise.reject(error);
      }

      // ✅ Only for authenticated APIs
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/";
      return Promise.reject(error);
    }

    // ================================
    // 🔁 401 - ACCESS TOKEN EXPIRED → Refresh Token Flow
    // ================================
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem("refresh_token");
      if (!refreshToken) {
        window.location.href = "/";
        return Promise.reject(error);
      }

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/auth/refresh`,
          { refresh_token: refreshToken }
        );

        const newAccessToken = res.data.access_token;

        // Save new token
        localStorage.setItem("access_token", newAccessToken);
        sessionStorage.setItem("access_token", newAccessToken);

        // Update original request header
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

        // Retry original request
        return api(originalRequest);
      } catch (err) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/";
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
